var TEMPLATE_URL = require('./measurements.detail.html');
angular.module('ikeweb.spike.measure').directive('measurementsDetail', function() {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            measurements: '=',
            activeMeasurement: '=',
            activateMeasurement: '=',
            note: '='
        },
        controller: 'MeasurementsDetailController',
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: TEMPLATE_URL,
        link: function($scope, $element, attrs, ctrl) {
            $scope.$watch('ctrl.measurements', ctrl.updateSelectedMeasurement);
            $scope.$watch('ctrl.note', ctrl.noteUpdated);

        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./src/client/components/spike/measure/measurements-detail/measurements.detail.directive.js
// module id = 570
// module chunks = 0